import axios from 'axios';
import { getAuthHeader } from './authService';

const API_BASE_URL = '/api';

export interface RiskAlert {
  id: number;
  student: string;
  studentName: string;
  type: string;
  riskLevel: string;
  assessment: string;
  totalScore: number;
  date: string;
  status: string;
  assignedProviderId?: number;
  assignedProviderName?: string;
  assignedDate?: string;
  notes?: string;
  depressionScore?: number;
  anxietyScore?: number;
  stressScore?: number;
}

export interface AssignProviderRequest {
  alertId: number;
  providerId: number;
  notes?: string;
}

export interface UpdateAlertStatusRequest {
  alertId: number;
  status: string;
  notes?: string;
}

export interface Provider {
  userId: number;
  firstName: string;
  lastName: string;
  email: string;
}

const riskAlertService = {
  getRecentAlerts: async (): Promise<RiskAlert[]> => {
    const response = await axios.get(`${API_BASE_URL}/reports/recent-alerts`, { headers: getAuthHeader() });
    return response.data;
  },

  assignProvider: async (request: AssignProviderRequest): Promise<void> => {
    await axios.post(`${API_BASE_URL}/reports/alerts/assign-provider`, request, { headers: getAuthHeader() });
  },

  updateAlertStatus: async (request: UpdateAlertStatusRequest): Promise<void> => {
    await axios.post(`${API_BASE_URL}/reports/alerts/update-status`, request, { headers: getAuthHeader() });
  },

  markAsUrgent: async (alertId: number): Promise<void> => {
    await riskAlertService.updateAlertStatus({
      alertId,
      status: 'URGENT',
      notes: 'Marked as urgent for immediate attention'
    });
  },

  getAvailableProviders: async (): Promise<Provider[]> => {
    const response = await axios.get(`${API_BASE_URL}/users/providers`, { headers: getAuthHeader() });
    return response.data;
  }
};

export default riskAlertService;